export default __webpack_public_path__ + "static/media/wallet07.573b6f8c.png";